import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HistoryService } from '../services/history.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-filing-history',
  templateUrl: './filing-history.component.html',
  styleUrls: ['./filing-history.component.scss']
})
export class FilingHistoryComponent implements OnInit {
 
  public tpno : number;
  public filings : Array<IFiling>;
  public filingHistory$: Observable<boolean>;
  public selectedCriteria:number=0;
  public searchValue: any = '';
  dtOptions: DataTables.Settings = {};
  // We use this trigger because fetching the list of purpose can be quite long,
  // thus we ensure the data is fetched before rendering
  dtTrigger: Subject<any> = new Subject();

  searchCriteria = [
    {value: "0", desc: "SELECT SEARCH CRITERIA"},
    {value: "1", desc: "TAX ACCOUNT NO."},
    {value: "2", desc: "TAX TYPE"},
    {value: "3", desc: "TAX PERIOD"},
    {value: "4", desc: "PERIOD START DATE"},
    {value: "5", desc: "PERIOD END DATE"},
    {value: "6", desc: "PERIOD DUE DATE"},
    {value: "7", desc: "RECEIVED DATE"}
  ];
  constructor(private history : HistoryService) { }
  

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      processing: true,
      paging:   true,
      ordering: true,
      info:     true
    };
    this.tpno = parseInt(localStorage.getItem("tpn"));
    this.filingHistory$ = this.history.getFilingHistorys(this.tpno).pipe(tap(r => {
        this.filings = this.history.filingHistorys;
    }))
  }

  filterFilingHistory(criteria:number, searchvalue:any){
    let originalPaymentData = this.filings;
    this.selectedCriteria= criteria;
    this.searchValue = searchvalue;
    if(this.selectedCriteria==1 && this.searchValue != ""){
      this.filings = this.filings.filter(element=>element.TAX_ACCOUNT_NO==this.searchValue);
    }
    else if(this.selectedCriteria==2 && this.searchValue != ""){
      this.filings = this.filings.filter(e=>e.TAX_TYPE==this.searchValue)
    }
    else if(this.selectedCriteria==3 && this.searchValue != ""){
      this.filings=this.filings.filter(e=>e.TAX_PERIOD==this.searchValue)
    }
    else if(this.selectedCriteria==4 && this.searchValue != ""){
      this.filings=this.filings.filter(e=>e.PERIOD_START_DATE==this.searchValue)
    }
    else if(this.selectedCriteria==5 && this.searchValue != ""){
      this.filings= this.filings.filter(e=>e.PERIOD_END_DATE==this.searchValue);
    }
    else if(this.selectedCriteria==6 && this.searchValue != ""){
      this.filings= this.filings.filter(e=>e.PERIOD_DUE_DATE==this.searchValue);
    }
    else if(this.selectedCriteria==6 && this.searchValue != ""){
      this.filings= this.filings.filter(e=>e.RECEIVED_DATE==this.searchValue);
    }
    else{
      this.filings = originalPaymentData;
    }
   
  }
}
